"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { buildStoryReaderHref } from "@/lib/analytics/story-analytics";
interface StoryReaderLinkProps {
  readerHrefBase: string;
  chapterId: string;
  className?: string;
  children: React.ReactNode;
}
function AttributedStoryReaderLink(t0) {
  const $ = _c(8);
  const {
    readerHrefBase,
    chapterId,
    className,
    children
  } = t0;
  const params = useSearchParams();
  let t1;
  if ($[0] !== chapterId || $[1] !== params || $[2] !== readerHrefBase) {
    t1 = buildStoryReaderHref(readerHrefBase, chapterId, params.get("utm_source"));
    $[0] = chapterId;
    $[1] = params;
    $[2] = readerHrefBase;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const href = t1;
  let t2;
  if ($[4] !== children || $[5] !== className || $[6] !== href) {
    t2 = <Link href={href} className={className}>{children}</Link>;
    $[4] = children;
    $[5] = className;
    $[6] = href;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function StoryReaderLink(props) {
  const $ = _c(12);
  let t0;
  if ($[0] !== props.chapterId || $[1] !== props.readerHrefBase) {
    t0 = buildStoryReaderHref(props.readerHrefBase, props.chapterId);
    $[0] = props.chapterId;
    $[1] = props.readerHrefBase;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const fallbackHref = t0;
  let t1;
  if ($[3] !== fallbackHref || $[4] !== props.children || $[5] !== props.className) {
    t1 = <Link href={fallbackHref} className={props.className}>{props.children}</Link>;
    $[3] = fallbackHref;
    $[4] = props.children;
    $[5] = props.className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props) {
    t2 = <AttributedStoryReaderLink {...props} />;
    $[7] = props;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <Suspense fallback={t1}>{t2}</Suspense>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}